import { render, staticRenderFns } from "./blank-file-svg.vue?vue&type=template&id=3310e780&scoped=true&"
var script = {}
import style0 from "./blank-file-svg.vue?vue&type=style&index=0&id=3310e780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310e780",
  null
  
)

export default component.exports